module.exports = new __parcel__URL__("kiran.13b46ca1.png").toString();